import { dispatchTrackingEvent } from '@context/tracking/utils';

/**
 * Rich content is split into three sections. Each percentage represents how far
 * down the rich content the user has gotten once the matching section has been
 * viewed (0-33%, 34-66%, 67-100%).
 */
export const RICH_CONTENT_SECTION_PERCENTS = [33, 66, 99] as const;

export type RichContentSectionPercent =
  (typeof RICH_CONTENT_SECTION_PERCENTS)[number];

interface TrackRichContentSectionViewParams {
  section: RichContentSectionPercent;
  interaction: 'scroll' | 'automatic';
  timing: number;
}

export const trackRichContentSectionView = ({
  section,
  interaction,
  timing,
}: TrackRichContentSectionViewParams) => {
  dispatchTrackingEvent({
    event: 'component_view',
    component: {
      name: `richcontent_view_${section}`,
      location: 0,
      position: 0,
      type: 'views',
      interaction,
      timing,
      items: [],
    },
    _clear: true,
  });
};
